import { render, staticRenderFns } from "./DestinationPanel.vue?vue&type=template&id=3bd951eb&"
import script from "./DestinationPanel.vue?vue&type=script&lang=js&"
export * from "./DestinationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports